import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import CommonFooter from "../components/CommonFooter/CommonFooter";
import InnovativeHeroSec from "../components/innovativeFarmingSolutions/InnovativeHeroSec";
import InnovativeProducts from "../components/innovativeFarmingSolutions/InnovativeProducts";
import Innovativetestimonials from "../components/innovativeFarmingSolutions/Innovativetestimonials";
import ShopByCategory from "../components/HomePage/ShopByCategory";

const InnovativeSolution = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      {/* <InnovativeHeroSec /> */}
      <InnovativeProducts />
      <ShopByCategory />
      <Innovativetestimonials />
      <CommonFooter />
    </div>
  );
};

export default InnovativeSolution;
